import { FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { CriteriaValue } from '../types';

export function mapConditionsToCriteria(mappedConditions: any[]): CriteriaValue[] {
  return mappedConditions.map(condition => {
    const fact = condition.fact;

    if (fact in FACT_NAMES_NUMERIC) {
      return {
        fact,
        number: {
          min: condition.minValue ?? null,
          max: condition.maxValue ?? null,
        },
        boolean: { value: false },
        string: { value: [] },
        isRequiredToQuote: false,
      };
    }

    if (fact in FACT_NAMES_STRING) {
      return {
        fact,
        string: {
          value: Array.isArray(condition?.exactMatch)
            ? condition?.exactMatch.map((value: any) => ({ label: value, value }))
            : [condition?.exactMatch].filter(Boolean),
        },
        boolean: { value: false },
        number: { min: null, max: null },
        isRequiredToQuote: false,
      };
    }

    return {
      fact,
      boolean: { value: condition.value },
      string: { value: [] },
      number: { min: null, max: null },
      isRequiredToQuote: false,
    };
  });
}
